export default "__VITE_ASSET__gadZrxop__"